import * as types from "./TenantManagementActionType";

// Action to fetch the list of tenants

export const fetchtenantManagementRequest = () => ({
  type: types.TENANTMANAGEMENT_REQUEST,
});
export const fetchTenantManagementSuccess = (data) => ({
  type: types.TENANTMANAGEMENT_SUCCESS,
  payload: data,
});
export const fetchTenantManagementFailure = (error) => ({
  type: types.TENANTMANAGEMENT_FAILURE,
  payload: error,
});

// Action to get tenant by ID

export const getTenantByIdRequest = (tenantId) => ({
  type: types.GET_TENANT_BY_ID_REQUEST,
  payload: tenantId,
});
export const getTenantByIdSuccess = (data) => ({
  type: types.GET_TENANT_BY_ID_SUCCESS,
  payload: data,
});
export const getTenantByIdFailure = (error) => ({
  type: types.GET_TENANT_BY_ID_FAILURE,
  payload: error,
});

// Action to save tenant details

export const saveTenantDetailsRequest = (tenantData) => ({
  type: types.SAVE_TENANT_DETAILS_REQUEST,
  payload: tenantData,
});
export const saveTenantDetailsSuccess = (data) => ({
  type: types.SAVE_TENANT_DETAILS_SUCCESS,
  payload: data,
});
export const saveTenantDetailsFailure = (error) => ({
  type: types.SAVE_TENANT_DETAILS_FAILURE,
  payload: error,
});

// Action to get all master tenant types for dropdown

export const getAllMasterTenantTypesRequest = () => ({
  type: types.GET_ALL_MASTER_TENANT_TYPES_REQUEST,
});
export const getAllMasterTenantTypesSuccess = (data) => ({
  type: types.GET_ALL_MASTER_TENANT_TYPES_SUCCESS,
  payload: data,
});
export const getAllMasterTenantTypesFailure = (error) => ({
  type: types.GET_ALL_MASTER_TENANT_TYPES_FAILURE,
  payload: error,
});

// Action to save tenant

export const saveTenantRequest = (tenantData) => ({
  type: types.SAVE_TENANT_REQUEST,
  payload: tenantData,
});
export const saveTenantSuccess = (data) => ({
  type: types.SAVE_TENANT_SUCCESS,
  payload: data,
});
export const saveTenantFailure = (error) => ({
  type: types.SAVE_TENANT_FAILURE,
  payload: error,
});

// Action to get storage category dropdown

export const getStorageCategoryDropdownRequest = () => ({
  type: types.GET_STORAGE_CATEGORY_DROPDOWN_REQUEST,
});
export const getStorageCategoryDropdownSuccess = (data) => ({
  type: types.GET_STORAGE_CATEGORY_DROPDOWN_SUCCESS,
  payload: data,
});
export const getStorageCategoryDropdownFailure = (error) => ({
  type: types.GET_STORAGE_CATEGORY_DROPDOWN_FAILURE,
  payload: error,
});

// Action to get all master country dropdowns

export const getAllMasterCountryRequest = () => ({
  type: types.GET_ALL_MASTER_COUNTRY_REQUEST,
});
export const getAllMasterCountrySuccess = (data) => ({
  type: types.GET_ALL_MASTER_COUNTRY_SUCCESS,
  payload: data,
});
export const getAllMasterCountryFailure = (error) => ({
  type: types.GET_ALL_MASTER_COUNTRY_FAILURE,
  payload: error,
});

// Action to get all master timezone dropdowns

export const getAllMasterTimeZoneRequest = () => ({
  type: types.GET_ALL_MASTER_TIMEZONE_REQUEST,
});
export const getAllMasterTimeZoneSuccess = (data) => ({
  type: types.GET_ALL_MASTER_TIMEZONE_SUCCESS,
  payload: data,
});
export const getAllMasterTimeZoneFailure = (error) => ({
  type: types.GET_ALL_MASTER_TIMEZONE_FAILURE,
  payload: error,
});

// Action to activate/deactivate tenant management
export const activateDeactivateTenantRequest = (tenantId, isActive) => ({
  type: types.ACTIVATE_DEACTIVATE_TENANT_REQUEST,
  payload: { tenantId, isActive },
});
export const activateDeactivateTenantSuccess = (data) => ({
  type: types.ACTIVATE_DEACTIVATE_TENANT_SUCCESS,
  payload: data,
});
export const activateDeactivateTenantFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_TENANT_FAILURE,
  payload: error,
});

// Action to soft delete tenant
export const deleteTenantRequest = (tenantId, modifiedBy) => ({
  type: types.DELETE_TENANT_REQUEST,
  payload: { tenantId, modifiedBy },
});
export const deleteTenantSuccess = (data) => ({
  type: types.DELETE_TENANT_SUCCESS,
  payload: data,
});
export const deleteTenantFailure = (error) => ({
  type: types.DELETE_TENANT_FAILURE,
  payload: error,
});
